import React, { useState, useRef, useEffect } from "react";
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-control-geocoder/dist/Control.Geocoder.css";

import L from "leaflet";
import { LuUpload } from "react-icons/lu";
import { FaTools } from "react-icons/fa"; // Maintenance icon
import KmlRead from "./KmlRead";
import ClassOverlay from "./ClassOverlay";
import ClassLegend from "./ClassLegend";
import OpacitySlider from "../OpacityButton/OpacitySlider";
import { checkPageStatus } from "../../utilityhook/pagecheck"; // ✅ import utility

const pakistanCoordinates = [33.6844, 73.0479];

const Classification = () => {
  const [mapCenter, setMapCenter] = useState(pakistanCoordinates);
  const [imageSelector, setOpenImgSelecter] = useState(false);
  const [coord, setCoord] = useState([]);
  const [selectedParameter, setselectedParameter] = useState("Classification");
  const [flag, setFlag] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isActive, setIsActive] = useState(true); // ✅ track maintenance status
  const mapRef = useRef(null);

  // Define color mappings for each parameter
  const colorMapping = {
    Classification: [
      { color: "#3F810A", label: "Other Crops" },
      { color: "#F4A510", label: "Wheat" },
    ],
  };

useEffect(() => {
  const fetchPageStatus = async () => {
    const active = await checkPageStatus("5-classification"); // ✅ wait for backend or localStorage
    setIsActive(active);
  };
  fetchPageStatus();
}, []);

  useEffect(() => {
    if (coord.length > 0 && mapRef.current) {
      const bounds = L.latLngBounds(coord);
      mapRef.current.fitBounds(bounds);
    }
  }, [coord]);

  const bond = (coord) => {
    setCoord(coord);
  };
  const handleFlag = (flag) => {
    setFlag(flag);
  };

  return (
    <>
      <div className="w-full lg:w-[96%] h-screen overflow-hidden pl-[1vw] absolute right-0 ">
        <div className="flex md:pl-5 items-center  w-full gap-2">
          <h1 className="bg-[#dbeafe] h-10 w-[92vw] rounded-sm pt-1 text-center text-sm sm:text-[16px] ml-2 mt-4 2xl:text-lg font-medium">
            <p>
              <span className=" text-2xl font-bold text-wrap">
                Crop Classification
              </span>
            </p>
          </h1>
        </div>

        {/* Content Section */}
        <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center h-[90vh] w-[95vw] md:mt-5 mt-7">
          {/* Map Container */}
          <div className="h-[80vh] lg:h-[90vh] w-full lg:w-[93vw] overflow-hidden rounded-md shadow-md md:ml-5 shadow-black relative">
            <div className="flex h-full w-full">
              <MapContainer
                center={mapCenter}
                zoom={10}
                className="w-full h-full"
                whenCreated={(mapInstance) => (mapRef.current = mapInstance)}
              >
                <TileLayer url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga" />

                {flag && coord.length > 0 && (
                  <ClassLegend
                    selectedParameter={selectedParameter}
                    colorMapping={colorMapping}
                  />
                )}

                <div className="relative">
                  <div
                    className="absolute btn btn-circle top-4 left-14 z-[500] group"
                    onClick={() => {
                      setOpenImgSelecter(true);
                    }}
                  >
                    <LuUpload size={25} />
                    {/* Tooltip */}
                    <span className="absolute left-[3vw] w-32 top-1/2 transform -translate-y-1/2 bg-black text-white text-xs rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      Upload your file
                    </span>
                  </div>
                </div>

                <ClassOverlay flag={flag} coordinate={coord} />

                {flag && (
                  <div className="absolute top-4 right-4 z-[1000]">
                    <OpacitySlider />
                  </div>
                )}
              </MapContainer>
            </div>

            <div className={`${imageSelector ? "block" : "hidden"}`}>
              <KmlRead
                setOpenImgSelecter={setOpenImgSelecter}
                bond={bond}
                flag={handleFlag}
              />
            </div>

            {/* 🚧 Under Maintenance Overlay (only visible when inactive) */}
            {!isActive && (
              <div className="absolute inset-0 bg-gradient-to-br from-gray-100 via-gray-200 to-gray-300 bg-opacity-90 flex flex-col items-center justify-center text-center z-[9999] backdrop-blur-sm">
                <FaTools className="text-5xl text-green-500 mb-4 animate-bounce" />
                <h1 className="text-3xl md:text-5xl font-semibold text-gray-600 mb-2">
                  Page Under Maintenance
                </h1>
                <p className="text-gray-500 text-lg max-w-md">
                  We’re currently enhancing this feature for better accuracy and
                  user experience. Please check back soon!
                </p>
                <div className="mt-6">
                  <div className="w-16 h-16 border-4 border-gray-600 border-t-green-500 rounded-full animate-spin mx-auto"></div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Classification;
